import { gql } from "@apollo/client";

export const TRANSACTION_REPORT = gql`
  query reports_transactions_ticketing(
    $where: reports_transactions_ticketing_bool_exp!
    $offset: Int!
    $limit: Int!
  ) {
    reports_transactions_ticketing(
      where: $where
      limit: $limit
      offset: $offset
      order_by: { transaction_time: desc }
    ) {
      username
      order_items_count
      organization_id
      organization_name
      event_id
      event_name
      location_id
      location_name
      order_id
      transaction_date
      transaction_hour
      transaction_time
      order_mx_ref_id
      payment_ref_id
      order_status
      payment_status
      payment_type
      transaction_amount
      item_subtotal
      tax
      tip
      digital_surcharge
      applied_discount_amount
      applied_discount_name
      vendor_name
      uid
      last4
      card_type
      device_app_id
      items_json
      is_tab
      tab_name
      tab_nickname
      promo_code_uid
      build_id
      email
      attendee_id
      total_promo_discount
    }
  }
`;
export const TRANSACTION_REPORT_COUNT = gql`
  query reports_transactions_ticketing(
    $where: reports_transactions_ticketing_bool_exp!
  ) {
    total: reports_transactions_ticketing_aggregate(where: $where) {
      aggregate {
        count
        __typename
      }
      __typename
    }
  }
`;
